import React from 'react';
import {Link} from 'react-router-dom'



function BreadCumbbird() {
  return (
    <section className="breadcrumb-area breadcrumb-bg"    
    style={{
    backgroundImage: 'url("img/bg/ssq.jpg")',
    height: window.innerWidth < 768 ? '10px' : '100px', // full height on mobile, reduced on web

    backgroundSize: "cover",
    backgroundPosition: "center",
  }}>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-content">
                <h2 className="title">Liste Oiseaux </h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Acceuil</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Liste Oiseaux</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      
  )
}

export default BreadCumbbird;
